export const authUrl = 'https://api.nguyencao.site/auth/v1/api';
export const studentUrl = 'https://api.nguyencao.site/student/v1/api';
export const teacherUrl = 'https://api.nguyencao.site/teacher/v1/api';
export const courseUrl = 'https://api.nguyencao.site/course/v1/api';
export const enrollmentUrl = 'https://api.nguyencao.site/enrollment/v1/api';
export const classUrl = 'https://api.nguyencao.site/class/v1/api';
export const semesterUrl = 'https://api.nguyencao.site/semester/v1/api';

export const authUrlSecure = 'https://api.nguyencao.site/secure/auth/v1/api';
export const studentUrlSecure =
    'https://api.nguyencao.site/secure/student/v1/api';
export const teacherUrlSecure =
    'https://api.nguyencao.site/secure/teacher/v1/api';
export const courseUrlSecure =
    'https://api.nguyencao.site/secure/course/v1/api';
export const enrollmentUrlSecure =
    'https://api.nguyencao.site/secure/enrollment/v1/api';
export const classUrlSecure = 'https://api.nguyencao.site/secure/class/v1/api';
export const semesterUrlSecure =
    'https://api.nguyencao.site/secure/semester/v1/api';
